import { getEnumValues } from "../common/enumOperations";
import { setFirstLetterToLowerCase } from "../common/stringOperations";
import { SystemDataType, SystemEntityType, SystemStorageType } from "./systemEdit/SystemEdit.types";

export const storageTypeOptions = (translateString: (key: string) => string) => {
    return getEnumValues(SystemStorageType).map((x) => {
        const name = translateString(setFirstLetterToLowerCase(SystemStorageType[x].toString()));
        return { name: name, id: x.toString() };
    });
};

export const entityTypeOptions = (translateString: (key: string) => string) => {
    return getEnumValues(SystemEntityType).map((x) => {
        const name = translateString(setFirstLetterToLowerCase(SystemEntityType[x].toString()));
        return { name: name, id: x.toString() };
    });
};

export const dataTypeOptions = (translateString: (key: string) => string) => {
    return getEnumValues(SystemDataType).map((x) => {
        const name = translateString(setFirstLetterToLowerCase(SystemDataType[x].toString()));
        return { name: name, id: x.toString() };
    });
};
